import React, { memo, useEffect, useRef } from 'react';

import config from 'config';
import {getGroupId} from '../../../../../AuthToken';

const getCustomCss = providerHasChat => `            
                        .collaboration-qna-root {
                            background-color: white !important;
                            height: 100% !important;
                            border-radius: 0 !important;
                        }
                        .collaboration-qna-qnaHeader {
                            border-bottom: 1px solid #DDDCD4;
                        }
                        .collaboration-qna-listItemWrapper {
                            background-color: white !important;
                        }
                        .loader-container {
                             background-color: white !important;
                        }
                        .collaboration-container {
                            height: 100% !important; 
                        }
                        .qna-view-container {
                            min-width: 300px !important;
                        }
                       .qna-header {
                            font-size: 2.4rem !important;
                        }
                        .collaboration-qna-answeredQuestionTitle {
                             background-color: white !important;
                        }
                        .send-icon-button svg {
                            fill: white !important;
                        }
                        .collaboration-IconButton-root:disabled {
                            background-color: #C5C5C5 !important;
                        }
                        .collaboration-QnaSort-sortContainer {
                            position: absolute;
                            top: 34px;
                            right: 34px;
                            border-bottom: 0 !important;
                            display: ${providerHasChat ? 'none' : 'block'}
                        }
                        .BZ-Agenda-Dropdown-Content {
                            left: -70px !important;
                        }
                        .collaboration-EngagementPanel-container {
                            height: 100% !important;
                        }                       
                        .collaboration-EngagementHeader-engagementHeaderContainer {
                            background: white !important;
                            border-bottom: none !important;
                            padding: 10px 24px 0px 24px !important;
                            min-height: 34px !important;
                        }
                        .collaboration-ChannelHeader-header {
                            padding: 0 32px 4px !important;
                        }
                        .engagement-header-container-not-selected {
                            display: none !important;
                        }
                        .engagement-header-go-back{
                            padding-top: 0px !important;
                            padding-bottom: 0px !important;
                            height: auto !important;
                        }
                        .engagement-header-container-not-selected {
                            display: none !important;
                        }
                        .collaboration-EngagementItem-engagementItemContainer {
                            margin: 8px 8px 0 !important;
                        }
                        .collaboration-DeleteMessageDialog-modalShadow {
                            border-radius: 0 !important;
                        }
                        .str-chat__list {
                            border-radius: 0 !important;
                        }
                        .collaboration-ChatMessageDialog-modalShadow {
                            border-radius: 0 !important;
                        `;

const RingQna = memo(({ session, event, mainColor, providerHasChat }) => {
    const ref = useRef();

    useEffect(() => {
        if (!ref.current) {
            return;
        }

        const scriptElement = document.createElement('script');
        scriptElement.src = `/auth/transfer/embed?eventId=${event.id}&groupId=${getGroupId()}&redirectUrl=${config.ringUrl}/embed.js`;

        const customCss = getCustomCss(providerHasChat);
        const customization = { mainColor };

        let customizationSerialize = '';
        try {
            customizationSerialize = JSON.stringify(customization);
        } catch {
            customizationSerialize = '';
        }

        scriptElement.setAttribute('data-bz-user-css', customCss.trim());
        scriptElement.setAttribute('data-bz-customization', customizationSerialize);

        const host = config.ringUrl.split('-attendees');

        if (host.length > 1) {
            scriptElement.setAttribute('data-bz-namespace', host[0].substr(8));
        }

        const uniqueName = event['unique-name'];
        scriptElement.setAttribute('data-bz-event-id', uniqueName);
        scriptElement.setAttribute('data-bz-session-id', session.id);
        scriptElement.setAttribute('data-bz-modules', 'Collaboration');

        ref.current.appendChild(scriptElement);
    }, []);

    return <div style={{ height: '100%' }} ref={ref} />;
});

export default RingQna;
